import script from "./app-no-script.vue?vue&type=script&lang=js"
export * from "./app-no-script.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/views/components/layout/app-no-script.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a748396"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a748396', __exports__)) {
    console.log('reload')
    api.reload('0a748396', __exports__)
  }
  
}


export default __exports__